import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted flatscreen TV, 1.2 x 0.7 m panel authored
// at true mounting height (centred around y = 1.4), screen facing +Z with the
// wall bracket behind on -Z.
const MATTE_BLACK = "#2e2e30";
const SCREEN = "#3a3f44";
const STEEL = "#aab2b8";

export const flatscreenTv = defineModel({
  id: "flatscreen-tv",
  batchId: "modern",
  name: "Flatscreen TV",
  tags: ["modern", "interior", "appliance", "electronics", "living-room", "wall-mounted"],
  summary: "A wall-mounted flat TV with a dark glass screen and a wall bracket behind.",
  tiles: { w: 1, h: 1 },
  footprint: 1.0,
  parts(): Part[] {
    return [
      // thin black panel
      { geometry: new THREE.BoxGeometry(1.2, 0.7, 0.05), color: MATTE_BLACK, position: [0, 1.4, 0] },
      // slightly lighter screen face inset on +Z
      { geometry: new THREE.BoxGeometry(1.12, 0.62, 0.012), color: SCREEN, position: [0, 1.4, 0.028] },
      // wall bracket plate behind (against the wall on -Z)
      { geometry: new THREE.BoxGeometry(0.3, 0.35, 0.04), color: STEEL, position: [0, 1.4, -0.045] },
      // small chin bar with the maker's badge tone
      { geometry: new THREE.BoxGeometry(0.14, 0.02, 0.01), color: STEEL, position: [0, 1.07, 0.031] },
    ];
  },
  animations: [],
});
